import { useState, useCallback, useMemo } from 'react';
import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { Col, Table, Row, Divider, Alert } from 'antd';
import { ExcelIcon } from 'icons';
import { Route, Routes, useNavigate } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import ActionModal from 'components/actionModal';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useInvoices from '../useInvoices';
import UIHelper from '../../../../../helpers/UIHelper';
import { useRecoilValue } from 'recoil';
import { getUser } from '../../../../../hooks/useUser';

const MainPage = () => {
  const user = useRecoilValue(getUser);
  const isAdmin = user?.superadmin || user?.master_admin;

  const {
    data,
    columns,
    filters,
    loading,
    onChangeTableFilter,
    handleDownloadExcel,
    onExportTo,
    filteredShops,
    filteredInactiveShops,
  } = useInvoices(true);
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleOnRow = useCallback(
    (record) => ({
      onClick: () => {
        navigate(`${record.id}`);
      },
    }),
    [navigate],
  );

  const updatedFilters = useMemo(() => {
    return filters.map((filter) => {
      if (filter.title === 'Insegna') {
        return {
          ...filter,
          values: filteredShops.map((shop) => ({
            value: shop.id,
            title: shop.title,
          })),
          inactiveValues: filteredInactiveShops.map((shop) => ({
            value: shop.id,
            title: shop.title,
          })),
        };
      } else {
        return filter;
      }
    });
  }, [filters, filteredShops, filteredInactiveShops]);

  const toggleExportModal = useCallback((e) => {
    e.stopPropagation();
    setShowModal((s) => !s);
  }, []);

  const clickOk = async () => {
    try {
      await onExportTo();
      setShowModal(false);
    } catch (e) {}
  };

  const exportModal = showModal ? (
    <ActionModal
      loading={loading}
      title={t('Export ot Nego')}
      description={t('Sei sicuro che vuoi esportare dati?')}
      yesBtnText={t('Si')}
      noBtnText={t('No')}
      onClickOk={clickOk}
      onCancel={toggleExportModal}
      type={'info'}
    />
  ) : null;

  return (
    <>
      <PageHeader title={t('Fatturato settimanale').toUpperCase()}>
        <Row gutter={16}>
          {isAdmin && (
            <Col>
              <Button
                big
                type={'red'}
                iconMargin
                onClick={toggleExportModal}
                loading={loading}
              >
                {t('Export to Nego')}
              </Button>
            </Col>
          )}
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
            >
              {t('Export')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Alert message={t('financeAlert')} type='warning' />
        <br />
        <Filters
          filters={updatedFilters}
          // filterByShoppingCenter
        />
        <Divider />
        <Table
          columns={UIHelper.assignTire(columns)}
          dataSource={data.invoices}
          pagination={data.pagination}
          onChange={onChangeTableFilter}
          loading={loading}
          scroll={{ x: 2000 }}
          onRow={handleOnRow}
        />
      </div>
      {exportModal}
      <Routes>
        <Route path={':id/delete'} element={<DeleteModal />} />
      </Routes>
    </>
  );
};

export default MainPage;
